import { Injectable, OnDestroy, signal, WritableSignal } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { OriginalUserFieldsFragment, OriginalUserGQL } from "../graphql/gql";
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './current-user.service';
import { AuthTokenService } from '../services/auth-token.service';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService implements OnDestroy {

  public originalUser: WritableSignal<OriginalUserFieldsFragment | null> = signal(null)
  public isImpersonated: WritableSignal<boolean> = signal(false)

  private currentUserSubscription: Subscription;

  constructor(
    private currentUserService: CurrentUserService,
    private originalUserGQL: OriginalUserGQL,
    private authTokenService: AuthTokenService,
  ) {
    this.currentUserSubscription = this.currentUserService.currentUser.subscribe(currentUser => {
      this.originalUserGQL.fetch().pipe(
        map(result => result.data.originalUser)
      ).subscribe(originalUser => {
        this.originalUser.set(originalUser)
        this.isImpersonated.set(currentUser?.currentUser?.id != originalUser?.id)
      });
    });
  }

  async impersonateUser(userId: string) {
    const params = new URLSearchParams({ id: userId })

    const response = await fetch(environment.legacyAppUrl + "/impersonate_user", {
      "headers": {
        "accept": "application/json",
        "content-type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": await this.authTokenService.getAuthenticityToken()
      },
      "body": params.toString(),
      "method": "POST",
      "credentials": 'include'
    });

    if(response.ok) {
      window.location.reload();
    }
  }

  async stopImpersonation() {
    const originalUser = this.originalUser()
    if(originalUser != null) {
      await this.impersonateUser(originalUser.id)
    }
  }

  ngOnDestroy(): void {
    this.currentUserSubscription.unsubscribe();
  }
}
